import { BrowserRouter, Route, Link, Routes, Navigate, Switch, HashRouter } from 'react-router-dom';

function Footer() {
  return (
    <div>

      {/* main-footer */}
      <footer className="main-footer bg-color-1">
        <div className="footer-top">
          <div className="shape">
            {/* <div className="shape-1 rotate-me" style={{backgroundImage: 'url(assets/images/shape/shape-14.png)'}} /> */}
            <div className="shape-2 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-14.png)' }} />
            <div className="shape-3" />
            <div className="shape-4" />
          </div>
          <div className="auto-container">
            <div className="row clearfix">
              <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                <div className="footer-widget logo-widget">
                  <div className="footer-logo">
                    <figure className="logo" style={{height:'150px'}}>
                      <img src="assets/images/logo-7.png" style={{height:'150px'}}alt="" title className='logo' /></figure>
                  </div>
                 <div className="text" style={{ textAlign: "center" }}>
                    <p> Empowering businesses with exceptional talent and creating opportunities for a brighter future. Together, we build success one connection at a time.

                    </p>

                  </div> 
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6 footer-column">
                <div className="footer-widget links-widget ml-70">
                  <div className="widget-title">
                    <h4>Usefull Links</h4>
                  </div>
                  <div className="widget-content">
                    <ul className="links-list clearfix">
                      <li className="current"><Link to="/">Home</Link>

                      </li>
                      {/* <li><Link to="/about">Company Overview</Link></li>
                      <li><Link to="/mission-vission">Mission, Vision and Core Values
                      </Link></li> */}
                      {/* <li className=""><Link to="/gallery">Gallery</Link>

                      </li> */}
                      {/* <li className=""><Link to="/products">Products</Link>

                      </li> */}
                      {/* <li className=""><Link to="/career">Career</Link>

                      </li> */}
                      <li className=""><Link to="/contact">Contact</Link>
                      </li>
                      <li className=""><Link to="/about">About Us</Link>
                      </li>
                      <li className=""><Link to="#">Terms & Conditions</Link>
                      </li>
                      <li className=""><Link to="#">Privacy Policy</Link>
                      </li>
                      {/* <li className=""><Link to="https://projects.erpthemes.com/" target='_blank'>Login</Link>
                      </li> */}

                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 footer-column">
                <div className="footer-widget subscribe-widget logo-widget">
                  <div className="widget-title">
                    <h4>Connect with us</h4>
                  </div>
                  <div className="widget-content text">

                    <ul className="info clearfix">
                      <li><i className="icon-26" />A306, park rest society, behind l&t knowledge city wagoriya, Vadodara(390019).</li>
                      <li><i className="icon-24" />Call Us: <a href="tel:+919099966379">+91 9099966379</a></li>
                      <li><i className="icon-25" /><a href="mailto:amosay08@hotmail.com">amosay08@hotmail.com</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom centred">
          <div className="auto-container">
            <div className="copyright">
              <p><a href="/">JobsTrinity</a> © 2024 All Right Reserved</p>
            </div>
          </div>
        </div>
      </footer>
      {/* main-footer end */}
      {/*Scroll to top*/}
      {/* <button className="scroll-top scroll-to-target" data-target="html">
      <span className="fal fa-angle-up" />
    </button> */}
    </div>
  );
}

export default Footer;
